import $axios from "axios";
import Qs from "qs";
import { baseUrl } from "../config/config";
// import VueRouter from "vue-router@3.0.6@vue-router";
import VueRouter from "vue-router";
$axios.defaults.withCredentials = true;
$axios.defaults.crossDomain = true;
var $http = $axios.create({
  baseURL: baseUrl,
  responseType: "json",
  timeout: 50000,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
  },
  transformRequest: [
    function (data) {
      if (data) {
        data = Qs.stringify(data);
      }
      return data;
    }
  ]
});

$axios.defaults.withCredentials=true;

// $http.interceptors.response.use(
//   response => {
//     var res = response.data;
//     if(res.login_status==404||res.login_status=='重新登陆'){
//       //this.$router.push('login')
//       console.log('重新登录');
//           this.getLogin();
//     }
//     if (res.code == '200') {
//       sessionStorage.setItem('test', '1')
//     }
//     return response;
//   },
//   error => {
//     if (error.response) {
//       switch (error.response.status) {
//           case 500:
//               //跳转登录
//               localStorage.removeItem('token');
//               localStorage.removeItem('cardcode');
//               localStorage.removeItem('web_title');
//               localStorage.removeItem('web_keywords');
//               localStorage.removeItem('web_description');
//               localStorage.removeItem('hot_search');
//               localStorage.removeItem('u_partcode');
//               this.getLogin();
//               break;
//       }
//   }
//     return Promise.reject(error.response.data);
//   }
// );

export default $http;



// WEBPACK FOOTER //
// ./src/units/request.js